import {preventativeInteraction as customersTerritoriesAndAccountManagers} from "./customers-territories-and-account-managers";
import {preventativeInteraction as externalCustomers} from "./external-customers";
import {preventativeInteraction as externalVendors} from "./external-vendors";
import {preventativeInteraction as externalProducts} from "./external-products";
import {preventativeInteraction as partDescription} from "./part-description";
import {preventativeInteraction as partTitle} from "./part-title";
import {preventativeInteraction as partShortDescription} from "./part-short-description";
import {preventativeInteraction as partNotes} from "./part-notes";
import {preventativeInteraction as partPriceLevels} from "./part-price-levels";
import {preventativeInteraction as partSerializability} from "./part-serializability";
import {preventativeInteraction as partDeliveryMode} from "./part-delivery-mode";
import {preventativeInteraction as partOnlineOrderEligibility} from "./part-online-order-eligibility";
import {preventativeInteraction as partTechnicalInformation} from "./part-technical-information";
import {preventativeInteraction as partUPC} from "./part-upc";
import {preventativeInteraction as partVisibility} from "./part-visibility";
import {preventativeInteraction as priceMatrices} from "./price-matrices";
import {preventativeInteraction as productCategoryAssignment} from "./product-category-assignment";
import {preventativeInteraction as productDimensions} from "./product-dimensions";
import {preventativeInteraction as productProperties} from "./product-properties";
import {preventativeInteraction as productPropertyOptions} from "./product-property-options";
import {preventativeInteraction as productVendors} from "./product-vendors";
import {preventativeInteraction as warehouseAlertThresholds} from "./warehouse-alert-thresholds";
import {preventativeInteraction as productsFromAnotherPartner} from "./products-from-another-partner";
import {preventativeInteraction as productVisibilityToOtherPartners} from "./product-visibility-to-other-partners";
import {preventativeInteraction as productTagAssignment} from "./product-tag-assignment";
import {preventativeInteraction as productFormAssignment} from "./product-form-assignment";
import {preventativeInteraction as productRelationAssignment} from "./product-relation-assignment";
import {preventativeInteraction as productCodeAssignment} from "./product-code-assignment";
import {preventativeInteraction as productWarehouseAssignment} from "./product-warehouse-assignment";
import {preventativeInteraction as removeProduct} from "./remove-product";
import {preventativeInteraction as productFlatShippingRates} from "./product-flat-shipping-rates";
import {preventativeInteraction as setInventoryAvailability} from "./set-inventory-availability";

export {PreventionInvalidityCode} from "./shared/invalidity-codes";

/** @type {Record<string, import('./shared/section-factories').PreventativeSectionConfig[]>} */
export const preventativeRegistry = {
    [partDescription.datasourceId]: partDescription.sections,
    [partTitle.datasourceId]: partTitle.sections,
    [partShortDescription.datasourceId]: partShortDescription.sections,
    [partNotes.datasourceId]: partNotes.sections,
    [partUPC.datasourceId]: partUPC.sections,
    [partVisibility.datasourceId]: partVisibility.sections,
    [partPriceLevels.datasourceId]: partPriceLevels.sections,
    [partSerializability.datasourceId]: partSerializability.sections,
    [partDeliveryMode.datasourceId]: partDeliveryMode.sections,
    [partOnlineOrderEligibility.datasourceId]: partOnlineOrderEligibility.sections,
    [productVisibilityToOtherPartners.datasourceId]: productVisibilityToOtherPartners.sections,
    [partTechnicalInformation.datasourceId]: partTechnicalInformation.sections,
    [warehouseAlertThresholds.datasourceId]: warehouseAlertThresholds.sections,
    [productDimensions.datasourceId]: productDimensions.sections,
    [productVendors.datasourceId]: productVendors.sections,
    [priceMatrices.datasourceId]: priceMatrices.sections,
    [productCategoryAssignment.datasourceId]: productCategoryAssignment.sections,
    [customersTerritoriesAndAccountManagers.datasourceId]: customersTerritoriesAndAccountManagers.sections,
    [externalCustomers.datasourceId]: externalCustomers.sections,
    [externalVendors.datasourceId]: externalVendors.sections,
    [externalProducts.datasourceId]: externalProducts.sections,
    [productProperties.datasourceId]: productProperties.sections,
    [productPropertyOptions.datasourceId]: productPropertyOptions.sections,
    [productsFromAnotherPartner.datasourceId]: productsFromAnotherPartner.sections,
    [productWarehouseAssignment.datasourceId]: productWarehouseAssignment.sections,
    [setInventoryAvailability.datasourceId]: setInventoryAvailability.sections,
    [productTagAssignment.datasourceId]: productTagAssignment.sections,
    [productFormAssignment.datasourceId]: productFormAssignment.sections,
    [productRelationAssignment.datasourceId]: productRelationAssignment.sections,
    [productCodeAssignment.datasourceId]: productCodeAssignment.sections,
    [removeProduct.datasourceId]: removeProduct.sections,
    [productFlatShippingRates.datasourceId]: productFlatShippingRates.sections,
};
